import * as commonScripts from '../common'

const cmpCampaign3Page = {
    component: null,
    init: function (element) {
        this.component = element
        const navbarLinksList = document.querySelectorAll(".fixed-nav li a")
        const gradStart = document.querySelector(".section-colorgradient")
        const ctaStart = document.querySelector(".cmp-multiple-cta")
        const parallaxEle = document.querySelector(".cmp-parallax")
        let offsettopvalue = 0
        let offsetbottomvalue = 0
        let ctaoffsettopvalue = 0

        window.addEventListener("scroll", e => {
            const scrollPos = window.scrollY

            navbarLinksList.forEach(navbarLink => {
                const section = document.querySelector(navbarLink.hash)
                if (scrollPos + 150 > section.offsetTop && scrollPos + 20 < section.offsetTop + section.offsetHeight) {
                    navbarLink.classList.add("active")
                } else {
                    navbarLink.classList.remove("active")
                }

                if (screen.height < 864) {
                    offsettopvalue = 864 - screen.height
                    offsetbottomvalue = 864 - screen.height + 300
                    ctaoffsettopvalue = offsettopvalue + 175
                }
                else if (screen.height > 864 && screen.height < 970) {
                    offsettopvalue = (screen.height * 1.3) - 864
                    offsetbottomvalue = 864 - (screen.height / 2.1) + 300
                    ctaoffsettopvalue = offsettopvalue - 45
                }
                else if (screen.height > 970 && screen.height < 1270) {
                    offsettopvalue = (screen.height * 1.28) - 864
                    offsetbottomvalue = 864 - (screen.height / 3) + 300
                    ctaoffsettopvalue = offsettopvalue - 180
                }
                else if (screen.height > 1271 && screen.height < 1430) {
                    offsettopvalue = (screen.height * 1.22) - 864
                    offsetbottomvalue = 864 - (screen.height / 10) + 300
                    ctaoffsettopvalue = offsettopvalue - 350
                }
                else if (screen.height > 1430 && screen.height < 1830) {
                    offsettopvalue = (screen.height * 1.21) - 864
                    offsetbottomvalue = 864 + 310
                    ctaoffsettopvalue = offsettopvalue - 550
                }
                else if (screen.height > 1830 && screen.height < 2150) {
                    offsettopvalue = (screen.height * 1.21) - 864
                    offsetbottomvalue = 864 + 720
                    ctaoffsettopvalue = (offsettopvalue / 6)
                }
                else if (screen.height > 2150 && screen.height < 4300) {
                    offsettopvalue = (screen.height * 1.21) - 864
                    offsetbottomvalue = screen.height / 1.15
                    ctaoffsettopvalue = (offsettopvalue / 10)
                }
                else if (screen.height > 4301) {
                    offsettopvalue = 500
                    ctaoffsettopvalue = 500
                    offsetbottomvalue = 2550
                }
                else {
                    offsettopvalue = 160
                    offsetbottomvalue = 470
                    ctaoffsettopvalue = 155
                }
                if ((navbarLink.offsetTop + scrollPos + offsettopvalue > parallaxEle.offsetTop + (parallaxEle.offsetHeight / 2.2) &&
                    navbarLink.offsetTop + scrollPos + navbarLink.offsetHeight + offsetbottomvalue < gradStart.offsetTop + gradStart.offsetHeight)
                    ||
                    ((navbarLink.offsetTop + scrollPos + offsettopvalue + ctaoffsettopvalue > ctaStart.offsetTop) &&
                        navbarLink.offsetTop + scrollPos + navbarLink.offsetHeight + offsetbottomvalue < ctaStart.offsetTop + ctaStart.offsetHeight)) {
                    navbarLink.classList.add("color-white")
                }
                else {
                    navbarLink.classList.remove("color-white")
                }
            })
        })
    }
}

export default cmpCampaign3Page
